import { render, staticRenderFns } from "./privacidad.vue?vue&type=template&id=709aff02&scoped=true&"
import script from "./privacidad.vue?vue&type=script&lang=js&"
export * from "./privacidad.vue?vue&type=script&lang=js&"
import style0 from "./privacidad.vue?vue&type=style&index=0&id=709aff02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709aff02",
  null
  
)

export default component.exports